import React, { useState, useEffect } from 'react';
import { Container, Nav } from 'react-bootstrap';
import Sidebar from '../components/Layout/Sidebar';
import CallsHistory from '../components/Statistics/CallsHistory';
import SmsHistory from '../components/Statistics/SmsHistory';
const StatisticsPage = () => {
  const [activeTab, setActiveTab] = useState('voice-outgoing');
  const [clientType, setClientType] = useState('voip');
  const [userType, setUserType] = useState(0); // <--- ДОДАТИ
  useEffect(() => {
    //const user = JSON.parse(localStorage.getItem('user') || '{}');
    const userStr = localStorage.getItem('user');
    const user = (userStr && userStr !== 'undefined' && userStr !== 'null') ? JSON.parse(userStr) : {};
    //const type = user.type || 0;
    const id_client_type = user.id_client_type || 0; // <--- ЗМІНИТИ з user.type на user.id_client_type
    setUserType(id_client_type); // <--- ДОДАТИ
    console.log("id_client_type =", id_client_type);
    
    // SMS типи: 0, 2, 3
    if ([0, 2, 3].includes(id_client_type)) {
      setClientType('sms');
      if (id_client_type === 2) setActiveTab('sms-outgoing');
      else if (id_client_type === 3) setActiveTab('sms-incoming');
      else setActiveTab('sms-outgoing'); // id_client_type 0 - обидва
    } 
    // VOIP типи: 1, 7, 8
    else if ([1, 7, 8].includes(id_client_type)) {
      setClientType('voip');
      if (id_client_type === 7) setActiveTab('voice-outgoing');
      else if (id_client_type === 8) setActiveTab('voice-incoming');
      else setActiveTab('voice-outgoing'); // id_client_type 1 - обидва
    }
  }, []);
  const showOutgoing = [0, 1, 2, 7].includes(userType); // <--- ДОДАТИ ПЕРЕД return
  const showIncoming = [0, 1, 3, 8].includes(userType); // <--- ДОДАТИ


  const renderContent = () => {
    switch (activeTab) {
      case 'voice-outgoing':
        return <CallsHistory direction="outgoing" />;
      case 'voice-incoming':
        return <CallsHistory direction="incoming" />;
      case 'sms-outgoing':
        return <SmsHistory direction="outgoing" />;
      case 'sms-incoming':
        return <SmsHistory direction="incoming" />;
      default:
        return <CallsHistory direction="outgoing" />;
    }
  };
  return (
    <div className="d-flex">
      <Sidebar />
      <div className="flex-grow-1">
        <Container fluid className="p-0">
          <Nav variant="tabs" className="mb-0">
            {clientType === 'voip' && showOutgoing && ( // <--- ДОДАТИ showOutgoing
              <Nav.Item>
                <Nav.Link active={activeTab === 'voice-outgoing'} onClick={() => setActiveTab('voice-outgoing')}>
                  Calls history outgoing
                </Nav.Link>
              </Nav.Item>
            )}
            {clientType === 'voip' && showIncoming && ( // <--- ДОДАТИ showIncoming
              <Nav.Item>
                <Nav.Link active={activeTab === 'voice-incoming'} onClick={() => setActiveTab('voice-incoming')}>
                  Calls history incoming
                </Nav.Link>
              </Nav.Item>
            )}
            {clientType === 'sms' && showOutgoing && ( // <--- ДОДАТИ showOutgoing
              <Nav.Item>
                <Nav.Link active={activeTab === 'sms-outgoing'} onClick={() => setActiveTab('sms-outgoing')}>
                  SMS history outgoing
                </Nav.Link>
              </Nav.Item>
            )}
            {clientType === 'sms' && showIncoming && ( // <--- ДОДАТИ showIncoming
              <Nav.Item>
                <Nav.Link active={activeTab === 'sms-incoming'} onClick={() => setActiveTab('sms-incoming')}>
                  SMS history incoming
                </Nav.Link>
              </Nav.Item>
            )}
          </Nav>
          {renderContent()}
        </Container>
      </div>
    </div>
  );
};
export default StatisticsPage;